export const createWidgetName = () => {
  window.newTime = window.newTime || Date.now();
  return "_widget_" + window.newTime++;
};
